import React, {useRef, useState} from "react";
import Modal from "react-responsive-modal";

import {validateMode} from "root/Modals/modalFunctions";
import {ModalGenericModes} from "root/Modals/ModalGeneric/ModalGeneric";
import ModalGenerateSurveys from "root/Modals/ModalGenerateSurveys/ModalGenerateSurveys";

const useModalGenerateSurveys = () =>
{
    const defaultState =  { openState: false, mode: 'none', title: null, message: null } ;

    const [dialog, setDialog]  = useState ( defaultState )  ;

    const resolvePromise = useRef(null);

    const onClickActivate = ({mode, year_to_generate, title, message} ) =>
    {
        validateMode(mode, ModalGenericModes);

        return new Promise((resolve, reject) => {

            resolvePromise.current = resolve ;

            setDialog ({ openState: true, mode: mode, year_to_generate: year_to_generate, title: title, message: message });
        })
    }

    const onCloseModal = () =>
    {
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( null ) ;
        }

        setDialog (defaultState);
    };

    const onSaveComplete = ( result ) =>
    {
        // Close the dialog
        setDialog (defaultState);

        // Tell the parent we're done
        if ( resolvePromise.current !== null )
        {
            resolvePromise.current ( result ) ;
        }
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && <ModalGenerateSurveys title={dialog.title} year_to_generate={dialog.year_to_generate} message={dialog.message} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode}/> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalGenerateSurveys ;
